import Unit from "./unit.js";

class UnitNonLinear extends Unit{
    constructor(id, fromBaseConversionFunction, toBaseConversionFunction, name, symbols) {
        super(id, NaN, name, symbols);

        if (typeof(fromBaseConversionFunction) !== 'function'){
            throw new TypeError('fromBaseConversionFunction must be an function');
        }

        if (typeof(toBaseConversionFunction) !== 'function'){
            throw new TypeError('fromBaseConversionFunction must be an function');
        }

        if (!(symbols instanceof Array)){
            throw new TypeError('symbols must be an array');
        }

        this.fromBaseConversionFunction = fromBaseConversionFunction;
        this.toBaseConversionFunction = toBaseConversionFunction;
    }

    convertFromBase(valueInBaseSystem){
        return this.fromBaseConversionFunction(valueInBaseSystem);
    }

    convertToBase(valueToConvert){
        return this.toBaseConversionFunction(valueToConvert);
    }
}

export default UnitNonLinear;